module.exports = __webpack_public_path__ + "img/twitter.29ea88a0.png";